import {
  fetchAndActivate,
  getRemoteConfig,
  getValue,
} from "firebase/remote-config";
import { firebaseApp } from "utils";

type RemoteConfigDefaults = Record<string, string | number | boolean>;

const DEFAULT_CONFIG: RemoteConfigDefaults = {
  supportPhoneNumber: "",
  supportEmail: "",
  specialist_dashboard_support_faq: JSON.stringify([]),
};

const remoteConfig = getRemoteConfig(firebaseApp);
remoteConfig.settings = {
  minimumFetchIntervalMillis:
    process.env.NODE_ENV === "development" ? 0 : 60 * 60 * 1000,
  fetchTimeoutMillis: 60 * 1000,
};
remoteConfig.defaultConfig = DEFAULT_CONFIG;

fetchAndActivate(remoteConfig)
  .then(() => console.info("RemoteConfig activated"))
  .catch((error) => console.error("RemoteConfig init failed", error));

export const getRemoteConfigValue = (key: string) => {
  return getValue(remoteConfig, key).asString();
};

export type fetchSupportValues = Record<string, string>;

export const fetchSupportContacts = (): fetchSupportValues => {
  const supportPhoneNumber = getRemoteConfigValue("supportPhoneNumber");
  const supportEmail = getRemoteConfigValue("supportEmail");
  if (!supportPhoneNumber) {
    return {
      supportPhoneNumber: "+97338488851",
    };
  }
  try {
    return {
      supportEmail,
      supportPhoneNumber,
    };
  } catch (error) {
    console.warn(
      "Failed to parse specialist_dashboard_support_faq from Remote Config",
      error,
    );
    return {};
  }
};
